import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import AudioGalleryItem from '@fec/frontend-aron/modules/media/AudioGalleryItem/AudioGalleryItem';
import {
  MEDIA_START,
  MEDIA_PLAYING,
  MEDIA_ENDED,
} from '@fec/assets/js/utils/event';
import { triggerEvent } from '@fec/assets/js/utils/event';

const AudioGallery = ({ assets }) => {
  const [activeAudioId, setActiveAudioId] = useState();

  useEffect(() => {
    const handleMediaPlaying = (event) => {
      setActiveAudioId(event.detail.frontendId);
    };

    window.addEventListener(MEDIA_PLAYING, handleMediaPlaying);
    return () => {
      window.removeEventListener(MEDIA_PLAYING, handleMediaPlaying);
    };
  }, []);

  useEffect(() => {
    const handleMediaEnded = (event) => {
      if (event.detail.frontendId === activeAudioId) {
        const activeAssetIndex = assets.findIndex(
          (asset) => asset.frontendId === activeAudioId,
        );

        if (activeAssetIndex !== -1) {
          const nextAsset = assets.at(activeAssetIndex + 1);
          if (nextAsset) {
            triggerEvent(MEDIA_START, { frontendId: nextAsset.frontendId });
          }
        }
      }
    };

    window.addEventListener(MEDIA_ENDED, handleMediaEnded);
    return () => {
      window.removeEventListener(MEDIA_ENDED, handleMediaEnded);
    };
  }, [activeAudioId]);

  return (
    <ol className="audio-gallery">
      {assets.map((asset) => (
        <AudioGalleryItem key={asset.frontendId} asset={asset} />
      ))}
    </ol>
  );
};

AudioGallery.propTypes = {
  assets: PropTypes.array,
};

export default AudioGallery;
